import templateUrl from './vatInput.html';
import './vatInput.less';

export default angular.module('eventix.common.directives.vatInput', [])
/**
 * @ngdoc directive
 * @name eventix.common.directives:vatInput
 * @restrict element
 * @description
 * Provides a vat input selector
 *
 * @param {String} name Name for the input element
 * @param {Integer} value Value of the input element
 * @param {Boolean} disable Force the VAT to zero
 */
    .component('vatInput', {
        templateUrl: templateUrl,
        bindings: {
            name: '@',
            value: '=',
            disable: '<'
        },
        controller: VatInputController
    }).name;

function VatInputController($scope, $filter, $translate, Company, Role, Vat) {
    const $ctrl = this;

    $ctrl.isAdmin = Role.isAuthorizedAs('Admin');

    $ctrl.value = 0;
    $ctrl.disable = false;
    $ctrl.company = null;

    $ctrl.vatRates = mapVatRates(Vat.getDefaultVatRates());
    $ctrl.selectedRate = _.get($ctrl.vatRates, 'none');
    $ctrl.isDefaultVat = true;

    $ctrl.selectVatRate = selectVatRate;
    $ctrl.selectVatRateOnEnter = selectVatRateOnEnter;
    $ctrl.vatBlur = vatBlur;
    $ctrl.vatClick = vatClick;

    $ctrl.$onInit = function() {
        if ($ctrl.disable) {
            $ctrl.value = 0;
        }

        Company.getMe()
            .then(company => {
                $ctrl.company = company;

                $ctrl.vatRates = mapVatRates(_.get(Vat.getAllVatRates(), company.country, Vat.getDefaultVatRates()));

                if (!_.has($ctrl.vatRates, 'other')) {
                    _.assign($ctrl.vatRates, mapVatRates(Vat.getOtherVatRate()));
                }
            })
            .finally(() => watchValue($ctrl.value));

        $scope.$watch('$ctrl.value', watchValue);
    };

    function selectVatRate(vatRate) {
        if (vatRate.disabled)
            return;

        $ctrl.selectedRate = vatRate;
        $ctrl.value = vatRate.value;

        if ($ctrl.selectedRate.type === 'other')
            $ctrl.isDefaultVat = false;
    }

    function selectVatRateOnEnter(event, vatRate) {
        if (event.which === 13) {
            $ctrl.selectVatRate(vatRate);
            $ctrl.isOpen = false;
        } else if (event.which === 27) {
            $ctrl.isOpen = false;
        }
    }

    function vatBlur() {
        if ($ctrl.selectedRate.type !== 'other') {
            $ctrl.isDefaultVat = true;
        }
    }

    /*
     * Compatibility fix for Firefox
     */
    function vatClick(event) {
        $(event.target).focus();
    }

    function watchValue(vatValue) {
        if (_.isNil(vatValue))
            return;

        $ctrl.selectedRate = findVatRateByValue(vatValue) || _.get($ctrl.vatRates, 'other');
    }

    function findVatRateByValue(vatValue) {
        return _.find($ctrl.vatRates, vatRate => {
            if (vatRate.type === 'other')
                return false;

            return vatRate.value === vatValue;
        });
    }

    function mapVatRates(rates) {
        return _.keyBy(_.map(rates, (value, key) => {
            return {
                type: key,
                value: value,
                label: $filter('capitalize')($translate.instant('common.vat.' + key)),
                sublabel: (_.isNil(value) ? '' : ' (' + value + '%)'),
                disabled: false
            };
        }), 'type');
    }
}
